// extracted by mini-css-extract-plugin
export var legendIndicator = "_gp-1";
export var legendRight = "_gp-0";